import type { DocWithContent } from '@/models/interfaces'

const PLACEHOLDER_ARTWORK_URL =
  'https://media.shortform.com/book-placeholder.png'

export function coverArtworkUrl(
  doc: Pick<DocWithContent, 'cover_image'>,
): string {
  return doc.cover_image ? `https:${doc.cover_image}` : PLACEHOLDER_ARTWORK_URL
}
